module.exports = __webpack_public_path__ + "img/front_range_waters.91e68d64.jpg";